import { useEffect, useState } from "react";
import { useDashboardApprovalsAndRequests } from "repositories/office-repository";
import { useSelector } from "react-redux";
import { getStorage } from "utils";
import constants from "../../../../constants";
import {
  updateEditTimesheetRequestStatus,
  updateTimesheetStatus,
} from "repositories/timesheet-repository";
import { cancelLeave, updateLeaveStatus } from "repositories/leave-repository";
import toast from "react-hot-toast";
import {
  acceptEventRequest,
  rejectEventRequest,
} from "repositories/scheduler-repository";
import { useAccountOwnerCommon } from "lib/Context/AccountOwner";

const pageSize = 12;
const useRequestAcceptModule = () => {
  const [pageNumber, setPageNumber] = useState(1);
  const [acceptAndReject, setAcceptAndReject] = useState([]);
  const [showLoader, setShowLoader] = useState(false);
  const [totalItems, setTotalItems] = useState(0);
  const [totalPages, setTotalPages] = useState(1);
  const [officeFilter, setOfficeFilter] = useState([]);
  const [staffFilter, setStaffFilter] = useState([]);
  const { effectiveOwnerId: ownerId } = useAccountOwnerCommon();

  const { isLoading, data } = useDashboardApprovalsAndRequests(
    ownerId,
    pageNumber,
    pageSize,
    staffFilter,
    officeFilter
  );

  useEffect(() => {
    if (pageNumber === 1) {
      if (!isLoading && data && data?.data) {
        setAcceptAndReject([...data?.data?.recentUpdates]);
        setTotalItems(data?.pagination?.totalItems);
        setTotalPages(data?.pagination?.totalPages);
      }
    } else if (!isLoading && data && data?.data) {
      setAcceptAndReject((prev) => [...prev, ...data?.data?.recentUpdates]);
      setTotalItems(data?.pagination?.totalItems);
      setTotalPages(data?.pagination?.totalPages);
    }
  }, [isLoading, data]);

  const acceptRejectTimesheet = async (timesheetId, statusId, reason) => {
    setShowLoader(true);
    try {
      await updateTimesheetStatus({
        timesheetId: timesheetId?.toString(),
        statusId: statusId,
        reason: reason ? reason : null,
      });
      setAcceptAndReject((prev) =>
        prev.filter((item) => item.timesheetId !== timesheetId)
      );
    } catch (error) {
      toast.error(error?.message);
    } finally {
      setShowLoader(false);
    }
  };

  const acceptRejectLeave = async (
    actionTypeId,
    isApproved,
    reasonForLeaveState
  ) => {
    setShowLoader(true);
    try {
      const response = await updateLeaveStatus({
        id: actionTypeId.toString(),
        isAccepted: isApproved,
        Comment: reasonForLeaveState ?? "",
      });
      setAcceptAndReject((prev) =>
        prev.filter((item) => item.leave_Id !== actionTypeId)
      );
      if (response?.message) {
        toast.success(response.message);
      }
    } catch (error) {
      toast.error(error?.message);
    } finally {
      setShowLoader(false);
    }
  };

  const acceptRejectEditTimesheetRequest = async (actionTypeId, isApproved) => {
    setShowLoader(true);
    try {
      await updateEditTimesheetRequestStatus(actionTypeId, isApproved);
      setAcceptAndReject((prev) =>
        prev.filter(
          (item) => item.clockInOutTimeSheetEditRequestId !== actionTypeId
        )
      );
    } catch (error) {
      toast.error(error?.message);
    } finally {
      setShowLoader(false);
    }
  };

  const acceptRejectShiftEvent = async (actionTypeId, isApproved, officeId) => {
    setShowLoader(true);
    try {
      if (isApproved) {
        await acceptEventRequest(actionTypeId, officeId);
      } else {
        await rejectEventRequest(actionTypeId, officeId);
      }
      setAcceptAndReject((prev) =>
        prev.filter((item) => item.eventShiftId !== actionTypeId)
      );
    } catch (error) {
      toast.error(error?.message);
    } finally {
      setShowLoader(false);
    }
  };
  const staffCancelLeaves = async (
    actionTypeId,
    officeId,
    isApproved,
    reason = ""
  ) => {
    setShowLoader(true);
    try {
      const params = {
        id: actionTypeId.toString(),
        Comment: reason,
        IsStaff: false,
        IsCancel: isApproved,
        officeId: officeId,
      };
      let res = await cancelLeave(params);
      if (res.status) {
        toast.success(res.message);
        setAcceptAndReject((prev) =>
          prev.filter((item) => item.leave_Id !== actionTypeId)
        );
      }
    } catch (err) {
      toast.error(err.message);
    } finally {
      setShowLoader(false);
    }
  };

  return {
    data: {
      isLoading,
      pageNumber,
      acceptAndReject,
      totalItems,
      totalPages,
      showLoader,
    },
    methods: {
      setPageNumber,
      setOfficeFilter,
      setStaffFilter,
      acceptRejectTimesheet,
      acceptRejectLeave,
      acceptRejectEditTimesheetRequest,
      acceptRejectShiftEvent,
      staffCancelLeaves,
    },
  };
};

export default useRequestAcceptModule;
